import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_AXIOS_HTTP;

Vue.use(VueAuth, {
  tokenDefaultName: "token",
  auth: {
    request: function(req, token) {
      this.options.http._setHeaders.call(this, req, {
        Authorization: "Bearer " + token
      });
    },
    response: function(res) {
      return res.data.token;
    }
  },

  authRedirect: {
    path: "/login"
  },

  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  loginData: {
    url: "login_check",
    method: "POST",
    fetchUser: true,
    redirect: null
  },
  logoutData: {
    url: "logout",
    method: "POST",
    redirect: "/login",
    fetchUser: true
  },
  refreshData: {
    enabled: false
  },
  fetchData: {
    url: "user_auth",
    method: "GET",
    enabled: true
  }
});
